export default "__VITE_ASSET__DjW4Y3pK__"